import { gameRunningStatuses } from 'config/gameRunningStatuses';

const defaultState = {
    periodPlayMatchedInfo: {
        isPeriodPlayMode: false,
        matchedInfo: {
            match: true,
            periodStartInTZ: '',
            periodEndInTZ: '',
            currentInTZ: ''
        }
    },
    parentUrl: '',
    utmFromParent: {},
    isTestMode: false,
    isPurePrizeGame: false,
    enablePasscodeVerify: false,
    hasUsablePasscode: false,
    passcode: '',
    // passcode 剩餘能使用的次數
    passcodeRemainingCount: 0,
    isfirstPassLoginSever: false,
    gameRunningStatus: '',
    reducePointMode: '',
    referralCode: ''
};

const UPDATE_PROMO_STATE = 'promoState/UPDATE_PROMO_STATE';

const reducer = (state = defaultState, action) => {
    switch (action.type) {
        case UPDATE_PROMO_STATE:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};

export default reducer;

export function suspendPromo() {
    return {
        type: UPDATE_PROMO_STATE,
        payload: { gameRunningStatus: gameRunningStatuses.SUSPEND }
    };
}

export function endPromo() {
    return {
        type: UPDATE_PROMO_STATE,
        payload: { gameRunningStatus: gameRunningStatuses.END }
    };
}

export function updateShowPasswordQualifyStatus(data) {
    return {
        type: UPDATE_PROMO_STATE,
        payload: data
    };
}

export function updateFirstPassLoginSeverStatus() {
    return {
        type: UPDATE_PROMO_STATE,
        payload: { isfirstPassLoginSever: false }
    };
}

export function setReferralCodeStatus(data) {
    return {
        type: UPDATE_PROMO_STATE,
        payload: data
    };
}
